/* tslint:disable:no-console */
import Vue from 'vue'
import { AxiosResponse } from 'axios'

export const handleError = (response: any) => {
   if (response.data !== undefined) {
      handleAxiosResponse(response)
   } else if (response.status && response.statusText) {
      handleAxiosResponse(response)
   } else  {
      console.error(response)
      let message = response.toString()
      if (message.indexOf('DOCTYPE') > -1) {
         message = ''
      }
      Vue.$toast.error(message, 'Oops, something went wrong')
   }
}

const handleAxiosResponse = (response: AxiosResponse) => {
   console.error(response.status, response.statusText, response.data)
   if (response.data && response.data.type && response.data.title && response.data.status) {
      const problem = response.data as ProblemDetails
      Vue.$toast.error(problem.title, 'Oops, something went wrong')
   } else if (response.data && response.data.ErrorMessage) {
      const commitResult = response.data as CommitResult
      Vue.$toast.error(commitResult.ErrorMessage, 'Oops, something went wrong')
   } else if (response.data && response.data['odata.error']) {
      handleODataError(response.data['odata.error'])
   } else if (response.data && response.data.ExceptionMessage) {
      const message = `${response.data.Message}: ${response.data.ExceptionMessage}`
      Vue.$toast.error(message, 'Oops, something went wrong')
   } else if (response.data && response.data.Message) {
      const message = JSON.stringify(response.data.Message)
      Vue.$toast.error(message, 'Oops, something went wrong')
   } else if (response.data) {
      const message = JSON.stringify(response.data)
      Vue.$toast.error(message, 'Oops, something went wrong')
   } else {
      const message = JSON.stringify(response)
      Vue.$toast.error(message, 'Oops, something went wrong')
   }
}

const handleODataError = (response: ODataError) => {
   if (response.message && response.message.value) {
      Vue.$toast.error(response.message.value, 'Oops, something went wrong')
   } else if (response.innererror && response.innererror.message) {
      Vue.$toast.error(response.innererror.message, 'Oops, something went wrong')
   } else if (response.code) {
      Vue.$toast.error(`Code: ${response.code}`, 'Oops, something went wrong')
   } else {
      const message = JSON.stringify(response)
      Vue.$toast.error(message, 'Oops, something went wrong')
   }
}

interface ODataError {
   code: string
   message: { lang: string; value: string }
   innererror: { message: string }
}
